export const getDealIdsStringFromMarkets = (markets) => {
  const deals = markets.reduce((d, market) => [...d, ...market.deal], []);

  return deals.map((d) => d.dealId).join(', ');
};
